import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { StudentIndividual } from '@modules/types/graphql';

export type Entity = Partial<StudentIndividual> | null;

@DecribeEntity('StudentIndividualEntity')
class StudentIndividualEntity extends BaseEntity {
    wantToServe: string;
    sports: string;
    pleasureActivities: string;
    specialSkills: string;
    unPleasureActivities: string;
    stressfulSituations: string;
    attitudeThings: string;
    selfCare: string;
    needToControlled: string[];
    needToControlledOther: string;
    preferCommunicate: string;
    communationDifficulties: string;
    characterTraits: string;
    badHabits: string;

    constructor(entity: Entity) {
        super(entity);

        this.wantToServe = entity?.wantToServe ?? '';
        this.sports = entity?.sports ?? '';
        this.pleasureActivities = entity?.pleasureActivities ?? '';
        this.specialSkills = entity?.specialSkills ?? '';
        this.unPleasureActivities = entity?.unPleasureActivities ?? '';
        this.stressfulSituations = entity?.stressfulSituations ?? '';
        this.attitudeThings = entity?.attitudeThings ?? '';
        this.selfCare = entity?.selfCare ?? '';
        this.needToControlled = (entity?.needToControlled ?? []).filter(Boolean) as string[];
        this.needToControlledOther = entity?.needToControlledOther ?? '';
        this.preferCommunicate = entity?.preferCommunicate ?? '';
        this.communationDifficulties = entity?.communationDifficulties ?? '';
        this.characterTraits = entity?.characterTraits ?? '';
        this.badHabits = entity?.badHabits ?? '';
    }
}

export { StudentIndividualEntity };
